import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { from, Observable, Subscription } from 'rxjs';
import { DataService } from '../data/data.service';
import { FunctionsService } from '../functions/functions.service';
import { FcmService } from '../fcm/fcm.service';
import { BreakpointService } from '../breakpoint/breakpoint.service';

const USER = 'user';
const ACCESS_TOKEN = 'accessToken';
const REFRESH_TOKEN = 'refreshToken';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private dataService: DataService,
    private functionService: FunctionsService,
    private storage: Storage,
    private navCtrl: NavController,
    private fcm:FcmService,
    private breakpoint: BreakpointService,

  ) { }

  // Wide screens swap the auth layout for the site chrome, so animating the
  // transition leaves the auth page on screen underneath the new header.
  private get navOpts() {
    return { animated: !this.breakpoint.isWide };
  }


  get accessToken():string {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  private async removeCredentials():Promise<void> {
    localStorage.removeItem(ACCESS_TOKEN);
    this.dataService.user = null;
    await this.storage.remove(USER)
    await this.storage.remove(REFRESH_TOKEN)
  }

  private async saveCredentials(user:any):Promise<void> {
    await this.storage.set(USER, user);
    await this.storage.set(REFRESH_TOKEN, user.refreshToken);
    localStorage.setItem(ACCESS_TOKEN, user.accessToken);
    this.dataService.user = user;
  }




  getRefreshToken():Observable<any> {
    let promise = new Promise(async (resolve, reject) => {
      let token = await this.storage.get(REFRESH_TOKEN);
      this.dataService
        .getData('/user/refreshToken?token=' + token)
        .subscribe(
          (res: any) => {
            localStorage.setItem(ACCESS_TOKEN, res.accessToken);
            resolve(res.token);
          },
          (e) => reject(e)
        );
    });
    return from(promise);
  }

  async login(body: any):Promise<void> {
    await this.functionService.showLoading();
    this.dataService.postData('/user/login', body).subscribe(
      async (user: any) => {
        await this.saveCredentials(user);
        this.functionService.dismissLoading();
        this.fcm.subscriptionToUser()
        if(!user?.status) {
          this.functionService.presentToast("سوف يتم تفعيل حسابك في وقت قريب");
          // return if registration required
          if(this.dataService.settings.loginRequired) return
        }
        this.navCtrl.navigateRoot("/tabs/tab1", this.navOpts)
        this.dataService.privatePrice = user.privatePrice
        // this.dataService.settings.loginRequired ?  this.navCtrl.navigateRoot(this.dataService.page) : this.navCtrl.navigateForward('/welcome');
      },
      (err) => {
        this.functionService.dismissLoading();
        this.functionService.presentToast(err.error?.message || 'خطأ بالشبكة');
      }
    );
  };


  async register(body: any):Promise<void> {
    await this.functionService.showLoading();
    this.dataService.postData('/user/register', body)
      .subscribe(
        async (user: any) => {
          await this.saveCredentials(user);
          this.dataService.user = user;
          localStorage.removeItem("verified")
          this.fcm.subscriptionToUser();
          if(!user?.status) {
            this.functionService.presentToast("سوف يتم تفعيل حسابك في وقت قريب");
            if(this.dataService.settings.loginRequired) return
          }
          this.navCtrl.navigateRoot('/tabs/tab1', this.navOpts)

          this.functionService.dismissLoading();
        }, async (err) => {
          await this.functionService.dismissLoading();
          if (err.status == 409) return this.functionService.presentToast(err?.error?.message || "خطأ بالشبكة");
      });
  };

  async changePassword(body:any):Promise<boolean> {
    await this.functionService.showLoading();
    return new Promise(resolve => {
      this.dataService.postData('/user/changePassword', body)
        .subscribe(
          async (user: any) => {
            await this.saveCredentials(user);
            this.dataService.user = user;
            this.functionService.dismissLoading();
            this.navCtrl.navigateRoot('/tabs/tab1', this.navOpts);
            localStorage.removeItem(`${body.phone}`);
            resolve(true);

          }, async (err) => {
            await this.functionService.dismissLoading();
            await this.functionService.presentToast(err?.error?.message)
            resolve(false)
        });
    })
  }

  async logOut():Promise<void | boolean> {
    await this.functionService.showLoading();
    await this.fcm.unsubscribe();
    await this.removeCredentials();
    this.functionService.dismissLoading();
    if(this.dataService.settings.loginRequired) return this.navCtrl.navigateRoot("/login", this.navOpts);
    return this.navCtrl.navigateRoot('/tabs/tab1', this.navOpts);
  }


  async userStatus():Promise<boolean> {
    return new Promise((resolve) => {
      this.dataService.getData(`/status`).subscribe(async (res: any) => {
        if (res.active) {
          await this.storage.set('user', res?.user);
          this.dataService.privatePrice = res.user.privatePrice
          resolve(res?.user)
        }else{
          this.functionService.presentToast(res.message);
          this.logOut();
        }
      },err => {
        resolve(false)
      });
    })
  }

}
